import { Cache } from "./cache";
var cache_default = new Cache();
export {
  cache_default as default
};
